import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faUsers, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons'
import { Divider, Empty, message, Popconfirm, Table, Tooltip, Tag } from 'antd'
import moment from 'moment/moment'

import EditLocationModal from './EditLocationModal'
import LocationEmployeesModal from './LocationEmployeesModal'
import Pagination from '../../../components/Pagination'

import { deleteLocation, updateLocation } from '../services'
import { handleError } from '../../../helpers'

export default function LocationsTable({ locations, reload, pagination, setPagination }) {
	const user = useSelector(state => state.auth.user)
	const [editRecordModal, setEditRecordModal] = useState(null)
	const [locationEmployeesModal, setLocationEmployeesModal] = useState(null)

	const handleToggle = location => {
		updateLocation(location.id, { 
			disabled_at: location.disabled_at ? null : moment().format('YYYY-MM-DD HH:mm:ss') 
		})
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}
	
	const columns = [
		{
			title: 'Id',
			dataIndex: 'id'
		},
		{
			title: 'Empresa',
			dataIndex: 'company',
			render: t => t.commercial_name ? t.commercial_name : t.legal_name
		},
		{
			title: 'Nombre de Sede',
			dataIndex: 'name'
		},
		{
			title: 'Dirección',
			dataIndex: 'address',
			render: (t, r) => `${t}, ${r.address_extra}`
		},
		{
			title: 'Ciudad',
			dataIndex: 'city',
		},
		{
			title: 'Departamento',
			dataIndex: 'department',
		},
		{
			title: 'Estado',
			dataIndex: 'disabled_at',
			render: t => t ? <Tag color="red">Inactiva</Tag> : <Tag color="green">Activa</Tag>
		},
		{
			title: 'Acciones',
			width: '130px',
			render: (t, r) => (
				<React.Fragment>
					{ (user.role === 'admin' || user.permissions.includes('edit_companies')) && (
						<React.Fragment>
							<Tooltip title="Editar" onClick={() => setEditRecordModal(r)}>
								<React.Fragment>
									<FontAwesomeIcon icon={faEdit} className="text-link" />
								</React.Fragment>
							</Tooltip>
							<Divider type='vertical' />							
							{ !r.disabled_at ? (
								<Tooltip title="Desactivar">
									<Popconfirm
										title="Esta acción no se puede revertir"
										okText="Desactivar"
										cancelText="Cancelar"
										onConfirm={() => handleToggle(r)}
									>
										<FontAwesomeIcon icon={faToggleOn} className="text-link" />
									</Popconfirm>
								</Tooltip>
							) : (
								<Tooltip title="Activar">
									<Popconfirm
										title="Esta acción no se puede revertir"
										okText="Activar"
										cancelText="Cancelar"
										onConfirm={() => handleToggle(r)}
									>
										<FontAwesomeIcon icon={faToggleOff} className="text-link" />
									</Popconfirm>
								</Tooltip>
							)}
							<Divider type='vertical' />
						</React.Fragment>
					)}
					{ (user.role === 'admin' || user.permissions.includes('view_companies')) && (
						<React.Fragment>
							<Tooltip title="Contactos Sede" onClick={() => setLocationEmployeesModal(r)}>
								<React.Fragment>
									<FontAwesomeIcon icon={faUsers} className="text-link" />
								</React.Fragment>
							</Tooltip>
						</React.Fragment>
					)}
					{ (user.role === 'admin' || user.permissions.includes('delete_companies')) && (
						<React.Fragment>
							<Divider type='vertical' />
							<Tooltip title="Eliminar">
								<React.Fragment>
									<Popconfirm
										title="Esta acción no se puede revertir"
										okText="Eliminar"
										cancelText="Cancelar"
										okButtonProps={{ danger:true }}
										onConfirm={() => handleDelete(r.id)}
									>
										<FontAwesomeIcon icon={faTrash} className="text-link" />
									</Popconfirm>
								</React.Fragment>
							</Tooltip>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	const handleDelete = id => {
		deleteLocation(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}
	
	return (
		<React.Fragment>
			<Table 
				dataSource={locations}
				rowKey={r => r.id}
				pagination={false}
				columns={columns}
				loading={!locations}
				size="small"
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						styles={{ image: { height: '80px' } }}
					/> 
				)}}
			/>
			<Pagination 
				pagination={pagination}
				setPagination={setPagination}
				reload={reload}
				className="mb-0"
			/>
			{ editRecordModal && (
				<EditLocationModal 
					visible
					onClose={() => setEditRecordModal(null)}
					location={editRecordModal}
					reload={reload}
				/>
			)}
			{ locationEmployeesModal && (
				<LocationEmployeesModal 
					visible
					onClose={() => setLocationEmployeesModal(null)}
					location={locationEmployeesModal}
				/>
			)}
		</React.Fragment>
	)
}